// extracted by mini-css-extract-plugin
export default {"myImage":"Completion_myImage__STmdU"};